module.exports = __webpack_public_path__ + "img/meme_07.acca1da9.jpg";